import React, { useState, useEffect, useCallback } from 'react'
import moment from 'moment'
import { Modal, Spinner } from 'react-bootstrap'
import PaymentDetailModal from '../../Payment/components/PaymentDetailModal/index'
import { TRANSACTION_STATUS_TEXT_COLOR } from '../constants'
import { getAmountCells } from '../utils'
import { ActionContainer, StatusText, StyledModalBody, StyledTable } from '../index.styles'
import { getPointTransaction } from '../../../services/point'

const UserPointTransactionModal = ({ userId, pointBalance, isOpen, onClose }) => {
  const [transactions, setTransactions] = useState([])
  const [selectedPayment, setSelectedPayment] = useState(null)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const fetchTransactions = useCallback(
    async (page) => {
      setIsLoadingMore(true)
      try {
        const {
          data,
          pagination: { hasNext },
        } = await getPointTransaction(userId, page)

        setTransactions((transactions) => (page === 1 ? data : [...transactions, ...data]))
        setPagination((pagination) => ({ ...pagination, hasNext: hasNext }))
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoadingMore(false)
      }
    },
    [userId],
  )

  useEffect(() => {
    if (isOpen) {
      fetchTransactions(pagination.page)
    }
  }, [fetchTransactions, pagination.page, isOpen])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      scrollable
      centered
      enforceFocus={false}
      style={{ background: 'rgba(0,0,0,0.5)' }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Point Transactions</Modal.Title>
      </Modal.Header>
      <StyledModalBody>
        <ActionContainer>
          <div>
            <span>นกพอยต์สะสม : </span>
            <span style={{ fontWeight: '700' }}>{pointBalance}</span>
          </div>
        </ActionContainer>
        <StyledTable>
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>แลก / คืนพอยต์</th>
              <th>ได้รับ</th>
              <th>ประเภท</th>
              <th>สร้างเมื่อ</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => {
              const amountCells = getAmountCells(transaction)

              return (
                <tr key={index}>
                  <td style={{ width: '10%' }}>{index + 1}</td>
                  {amountCells}
                  <td>
                    <StatusText color={TRANSACTION_STATUS_TEXT_COLOR[transaction.type]}>{transaction.type}</StatusText>
                  </td>
                  <td>{moment(transaction.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                </tr>
              )
            })}
          </tbody>
          <tfoot>
            {isLoadingMore ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </td>
              </tr>
            ) : (
              pagination.hasNext && (
                <tr>
                  <td colSpan={6} className="text-center">
                    <button
                      className="btn btn-primary p-2"
                      onClick={() => {
                        if (pagination.hasNext) {
                          setPagination((pagination) => ({
                            ...pagination,
                            page: pagination.page + 1,
                          }))
                        }
                      }}
                    >
                      โหลดเพิ่มเติม
                    </button>
                  </td>
                </tr>
              )
            )}
          </tfoot>
        </StyledTable>
      </StyledModalBody>
      <PaymentDetailModal
        payment={selectedPayment}
        setPayment={setSelectedPayment}
        onHide={() => setSelectedPayment(null)}
        isReadOnly
      />
    </Modal>
  )
}

export default UserPointTransactionModal
